export enum ShopeeAuthProvider {
  ShopeeApp = 'shopee_app',
  ShopeeWeb = 'shopee_web',
}

export const SHOPEE_OAUTH_CONTEXT_KEY = '@shopee-user/tob/shopee_oauth';
